
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import { debounce } from "lodash";
import { OptionsClass } from "@/domain/entities/MainApp";
import absolutePosition from "@/app/infrastructures/misc/common-library/dom/absolutePosition";
import { ErrorBookingV3 } from "@/domain/entities/CreateBookingV3";
import { createFocusTrap } from "focus-trap";

class Props {
  showButtonOpenList = prop<boolean>({
    default: false
  });
  originValue = prop<OptionsClass>({
    default: () => new OptionsClass(),
    required: true
  });
  deliveryServiceValues = prop<string[]>({
    default: () => [],
    required: true
  });
  clientSearchValue = prop<string>({
    default: "",
    required: true
  });
  clientOptions = prop<OptionsClass[]>({
    default: () => [],
    required: true
  });
  cityOptions = prop<OptionsClass[]>({
    default: () => [],
    required: true
  });
  clientValue = prop<OptionsClass>({
    default: () => new OptionsClass(),
    required: true
  });
  clientLoading = prop<boolean>({
    default: false,
    required: true
  });
  originLoading = prop<boolean>({
    default: false,
    required: true
  });
  deliveryServiceOptions = prop<OptionsClass[]>({
    default: () => [],
    required: true
  });
  error = prop<ErrorBookingV3>({
    default: () => new ErrorBookingV3(),
    required: true
  });
  currentIndex = prop<number>({
    default: 0,
    required: true
  });
  clientIndex = prop<number>({
    default: 1,
    required: true
  });
  isDisabled = prop<boolean>({
    default: false
  });
  filterValues = prop<OptionsClass[]>({
    default: () => [],
    required: true
  });
}
@Options({
  name: "filter-client",
  components: {
    OverlayPanel
  }
})
export default class Filter extends Vue.with(Props) {
  isFilterOpen = false;
  focusTrap: any = null;

  get tooltipStyle() {
    return {
      fontFamily: "Montserrat",
      width: "419px",
      height: this.deliveryServiceValues.length ? "250px" : "200px",
      radius: "5px",
      border: "1px",
      borderColor: "#EAECF0",
      boxShadow: "0px 1px 2px 0px #00000014",
      backgroundColor: "#FFFFFF",
      color: "#4D4D4D",
      fontSize: "14px",
      marginTop: "3px"
    };
  }

  get clientSearchValueModel() {
    return this.clientSearchValue;
  }

  set clientSearchValueModel(searchValue: string) {
    this.$emit("update:clientSearchValue", searchValue);
  }

  get clientValueModel() {
    return this.clientValue;
  }

  set clientValueModel(clientValue: OptionsClass) {
    this.$emit("update:clientValue", clientValue);
  }

  get originValueModel() {
    return this.originValue;
  }

  set originValueModel(originValue: OptionsClass) {
    this.$emit("update:originValue", originValue);
  }

  get deliveryServiceValuesModel() {
    return this.deliveryServiceValues;
  }

  set deliveryServiceValuesModel(deliveryServiceValue: string[]) {
    this.$emit("update:deliveryServiceValues", deliveryServiceValue);
  }

  async openFilter(event: any) {
    const $refs: any = this.$refs;

    if ($refs.op.visible) return;
    $refs.op.show(event);
    await this.$nextTick();
    const container = document.getElementById("client-filter-op");
    if (!container) return;
    absolutePosition(container, event.currentTarget, $refs.op.visible);
    this.isFilterOpen = true;
    // if (event.pointerType) return
    await this.$nextTick();
    this.focusTrap = createFocusTrap(container, {
      escapeDeactivates: true,
      allowOutsideClick: true,
      returnFocusOnDeactivate: true,
      clickOutsideDeactivates: false,
      onDeactivate: () => {
        $refs.op.hide();
        this.focusTrap = null;
      }
    });
    this.focusTrap.activate();
  }

  async fetchOrigins(search = "", firstFetch = true) {
    if (this.originValue.name) return;
    this.$emit("fetchOrigins", { search, firstFetch });
  }

  fetchOriginsDebounced = debounce(async (search) => {
    this.fetchOrigins(search, true);
  }, 500);

  async fetchOriginsInfiniteScroll(search = "") {
    this.fetchOrigins(search, false);
  }

  deleteOriginValue() {
    this.$emit("deleteOriginValue");
  }

  deleteDeliveryService(index = 0) {
    this.$emit("deleteDeliveryService", index);
  }

  async fetchClients(search = "", isFirstFetch = true) {
    if (
      this.clientValue.name &&
      this.clientSearchValue !== this.clientValue.name
    )
      return;
    this.$emit("fetchClients", { search, isFirstFetch });
  }

  fetchClientsDebounced = debounce(async (search) => {
    this.fetchClients(search, true);
  }, 500);

  fetchClientsInfiniteScroll(search = "") {
    this.fetchClients(search, false);
  }

  onChangeFilter() {
    this.fetchClients(this.clientSearchValue);
  }

  onEscFilter() {
    if (this.focusTrap) {
      this.focusTrap.deactivate();
    }
  }
}
